// Third-party imports
import React from 'react';
import { useRecordContext } from 'react-admin';
import { Box, Typography, Paper } from '@mui/material';

// Local imports - types
import type { RepairDetail } from '@src/types';

const CustomerDisplay = () => {
  const record = useRecordContext<RepairDetail>();

  if (!record || !record.customer) return null;

  const { customer } = record;

  return (
    <Paper>
      <Box sx={{ padding: 2 }}>
        <Typography variant="h6" gutterBottom>Customer Information</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: 1, marginTop: 2 }}>
          <Typography variant="body2" fontWeight="bold">Name:</Typography>
          <Typography variant="body2">{customer.name || 'N/A'}</Typography>

          <Typography variant="body2" fontWeight="bold">Email:</Typography>
          <Typography variant="body2">{customer.email || 'N/A'}</Typography>

          <Typography variant="body2" fontWeight="bold">Phone:</Typography>
          <Typography variant="body2">{customer.phone || 'N/A'}</Typography>

          {customer.address && (
            <>
              <Typography variant="body2" fontWeight="bold">Address:</Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                {customer.address}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default CustomerDisplay;
